<template lang="html">
    <v-content>
    <v-card class="bioCard" width="80%" >
            <p>{{this.vuexState.celebID.birthName}}</p>
            <p>{{this.vuexState.celebID.birthDate}}</p>
    </v-card>
    <AssetFeed/>
</v-content>
</template>

<script>
import AssetFeed from '../components/AssetFeed.vue'

export default {
    name: 'celebPage',
    components: {
        AssetFeed
    },
    data: () => ({}),
    computed: {
        vuexState() {
            let temp = this.$store.state.celebs
            // this.celebPages = this.$store.state.celebPages
            // return celebPages
            return temp
        },
        user() {
            return this.$store.getters.activeCeleb
        }
    },
    created() {
        this.loadData()
    },
    watch: {
        $route() {
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.$store.commit('setActiveUser', {
                id: null
            })
            setTimeout(() => { // simulate async data fetching...
                this.$store.commit('setActiveUser', {
                    id: this.$route.params.id
                })
            }, 2000)
        }
    },
}
</script>

<style lang="css">

</style>
